import "./_intro-icons.scss";

import "./_intro-icons.scss";

document.addEventListener("DOMContentLoaded", () => {
    // Selezioniamo tutti i blocchi intro-icons nella pagina
    const blocks = document.querySelectorAll(".block__intro_icons");

    blocks.forEach((block) => {
        const fadeItems = block.querySelectorAll(".js-fade-up");
        if (fadeItems.length === 0) return;

        // Creiamo l'osservatore
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                // Se il blocco entra nel campo visivo
                if (entry.isIntersecting) {
                    
                    // Assegniamo a cascata la classe e il delay progressivo
                    fadeItems.forEach((item, index) => {
                        // Moltiplicatore di 150ms per ogni elemento successivo
                        item.style.transitionDelay = `${index * 0.3}s`;
                        
                        // Piccolo timeout per assicurarsi che il browser applichi il delay prima della classe
                        requestAnimationFrame(() => {
                            item.classList.add("is-visible");
                        });
                    });
                    
                    // Smettiamo di osservare il blocco (l'animazione avviene una sola volta)
                    obs.unobserve(block);
                }
            });
        }, { 
            threshold: 0.15 // L'animazione parte quando il 15% del blocco è visibile
        });

        observer.observe(block);
    });
});